import { Component, OnInit, AfterViewInit, Inject, Output, EventEmitter, ViewChildren, QueryList} from '@angular/core';
import { AdvancedSortableDirective, SortEvent } from '../../shared/directive/advanced-sortable.directive';
import { Router, NavigationEnd } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';
import { LanguageService } from '../../core/services/language.service';
import { global } from '../../core/services/pos-services/api.global';
import { EventService } from '../../core/services/event.service';
import { AuthenticationService } from '../../core/services/auth.service';
import { AuthfakeauthenticationService } from '../../core/services/authfake.service';
import { MENU } from './menu';
import { MenuItem } from './menu.model';
import { environment } from '../../../environments/environment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DecimalPipe } from '@angular/common'; 
import { UserService } from '../../core/services/pos-services/usuario.service';
import { ProductoService } from 'src/app/core/services/pos-services/producto.service';
import { ExcelService } from '../../core/services/pos-services/excel.service';
import { AdvancedService } from '../topbar/advanced.service';
import {ProductMin} from '../../core/models/pos.models/minstock'
import { Observable } from 'rxjs';

@Component({
  selector: 'app-horizontaltopbar',
  templateUrl: './horizontaltopbar.component.html',
  styleUrls: ['./horizontaltopbar.component.scss'],
  providers: [UserService, ProductoService, AdvancedService, DecimalPipe]
})

/**
 * Horizontal Topbar and navbar specified
 */
export class HorizontaltopbarComponent implements OnInit, AfterViewInit {
  @ViewChildren(AdvancedSortableDirective) headers: QueryList<AdvancedSortableDirective>;
  public userlocalstg;
  public nimage;
  public url:string;
  public cuser;
  element;
  cookieValue;
  flagvalue;
  countryName;
  valueset;

  menuItems = [];

  nuser:string; 

  listLang = [
    { text: 'English', flag: 'assets/images/flags/us.jpg', lang: 'en' },
    { text: 'Spanish', flag: 'assets/images/flags/spain.jpg', lang: 'es' },
    { text: 'German', flag: 'assets/images/flags/germany.jpg', lang: 'de' },
    { text: 'Italian', flag: 'assets/images/flags/italy.jpg', lang: 'it' },
    { text: 'Russian', flag: 'assets/images/flags/russia.jpg', lang: 'ru' },
  ];
  idlogusr: number; vnotifica:number=0;
  // Table data
  minProdData: ProductMin[];
  tableData: ProductMin[];
  hideme: boolean[] = [];
  tables$: Observable<ProductMin[]>;
  total$: Observable<number>;
  // tslint:disable-next-line: max-line-length
  constructor(
    @Inject(DOCUMENT) 
    private document: any, 
    private router: Router, 
    private eventService: EventService, 
    private authService: AuthenticationService,
    private authFackservice: AuthfakeauthenticationService,
    public languageService: LanguageService,
    private _userService: UserService,
    private _productoService: ProductoService,
    public service: AdvancedService,
    private modalService: NgbModal,
    private excelService: ExcelService,
    // tslint:disable-next-line: variable-name
    public _cookiesService: CookieService) {
      this.url = global.url;
      this.userlocalstg = this._userService.getIdentity();
      this.nuser = this.userlocalstg.usr[0].fcus_nombre;
      this.nimage = this.userlocalstg.usr[0].fcus_icon;
      this.idlogusr = this.userlocalstg.usr[0].fcus_id;
      this.imgPerfil();
      this.getProductosMin();
      router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          this.activateMenu();
        }
      });
  }

  ngOnInit(): void {
    this.cuser = this._userService.getIdentity();
    this.element = document.documentElement;

    this.initialize();

    this.cookieValue = this._cookiesService.get('lang');
    const val = this.listLang.filter(x => x.lang === this.cookieValue);
    this.countryName = val.map(element => element.text);
    if (val.length === 0) {
      if (this.flagvalue === undefined) { this.valueset = 'assets/images/flags/us.jpg'; }
    } else {
      this.flagvalue = val.map(element => element.flag);
    }
  }
  largeModalProdMin(largeDataModal: any) {
    this.modalService.open(largeDataModal, { size: 'xl', centered: true });
  }
  exportToExcel(): void {
    this.excelService.generateExcel(this.minProdData, 'Reporte_de_Productos_Stock_Minimo');
  }
  getProductosMin(){
    this._productoService.getStockMin().subscribe(
      response => {
        if(response.status == 'Success'){
          this.vnotifica+=1;
          
          if(response.type == 'Ok'){
            this.minProdData = response.product;
            this.tableData = this.minProdData;
            for (let i = 0; i <= this.tableData.length; i++) {
              this.hideme.push(true);
            }
            this.service.upTable$ = this.minProdData;
            this.tables$ = this.service.tables$;
            this.total$ = this.service.total$;
          }
        }
      },
      error => {
        console.log(error);
      });
  }
  setLanguage(text: string, lang: string, flag: string) {
    this.countryName = text;
    this.flagvalue = flag;
    this.cookieValue = lang;
    this.languageService.setLanguage(lang);
  }

  /**
   * Logout the user
   */
  logout() {
    if (environment.defaultauth === 'firebase') {
      this.authService.logout();
    } else {
      this.authFackservice.logout();
    }
    this.router.navigate(['/account/login']);
  }

  /**
   * On menu click
   */
  onMenuClick(event) {
    const nextEl = event.target.nextElementSibling;
    if (nextEl) {
      const parentEl = event.target.parentNode;
      if (parentEl) {
        parentEl.classList.remove("show");
      }
      nextEl.classList.toggle("show");
    }
    return false;
  }

  ngAfterViewInit() {
    this.activateMenu();
  }

  /**
   * remove active and mm-active class
   */
  _removeAllClass(className) {
    const els = document.getElementsByClassName(className);
    while (els[0]) {
      els[0].classList.remove(className);
    }
  }

  /**
   * Togglemenu bar
   */
  toggleMenubar() {
    const element = document.getElementById('topnav-menu-content');
    element.classList.toggle('show');
  }

  /**
   * Activates the menu
   */
  private activateMenu() {

    const resetParent = (el: any) => {
      const parent = el.parentElement;
      if (parent) {
        parent.classList.remove('active');
        const parent2 = parent.parentElement;
        this._removeAllClass('mm-active');
        this._removeAllClass('mm-show');
        if (parent2) {
          parent2.classList.remove('active');
          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove('active');
            const parent4 = parent3.parentElement;
            if (parent4) {
              parent4.classList.remove('active');
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove('active');
                const menuelement = document.getElementById("topnav-menu-content")
                if (menuelement !== null) {
                  if (menuelement.classList.contains('show'))
                    document
                      .getElementById("topnav-menu-content")
                      .classList.remove("show");
                }
              }
            }
          }
        }
      }
    };

    // activate menu item based on location
    const links = document.getElementsByClassName('side-nav-link-ref');
    let matchingMenuItem = null;
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < links.length; i++) {
      // reset menu
      resetParent(links[i]);
    }
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < links.length; i++) {
      // tslint:disable-next-line: no-string-literal
      if (location.pathname === links[i]['pathname']) {
        matchingMenuItem = links[i];
        break;
      }
    }

    if (matchingMenuItem) {
      const parent = matchingMenuItem.parentElement;
      /**
       * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
       * We should come up with non hard coded approach
       */
      if (parent) {
        parent.classList.add('active');
        const parent2 = parent.parentElement;
        if (parent2) {
          parent2.classList.add('active');
          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.add('active');
            const parent4 = parent3.parentElement;
            if (parent4) {
              parent4.classList.add('active');
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.add('active');
                const parent6 = parent5.parentElement;
                if (parent6) {
                  parent6.classList.add('active');
                }
              }
            }
          }
        }
      }
    }
  }

  /**
   * on settings button clicked from topbar
   */
  onSettingsButtonClicked() {
    document.body.classList.toggle('right-bar-enabled');
  }

  /**
   * Fullscreen method
   */
  fullscreen() {
    document.body.classList.toggle('fullscreen-enable');
    if (
      !document.fullscreenElement && !this.element.mozFullScreenElement &&
      !this.element.webkitFullscreenElement) {
      if (this.element.requestFullscreen) {
        this.element.requestFullscreen();
      } else if (this.element.mozRequestFullScreen) {
        /* Firefox */
        this.element.mozRequestFullScreen();
      } else if (this.element.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        this.element.webkitRequestFullscreen();
      } else if (this.element.msRequestFullscreen) {
        /* IE/Edge */
        this.element.msRequestFullscreen();
      }
    } else {
      if (this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        /* Firefox */
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        /* IE/Edge */
        this.document.msExitFullscreen();
      }
    }
  }

  /**
   * Initialize
   */
  initialize(): void {
    //--Validar permisos actuales del usuario--
    this.cuser.permiso.map(perm =>{
      let ipe = perm['shcpe_numero']; //--id de permiso asignado al usuario
      MENU.find((element) => {
        if(element.id === ipe){
          //--Verificar si hay subitems--
          if(element.subItems){
            let arrH = element.subItems, rwitem=[];
            //--Buscar en array de permisos de usuario si subitem existe
            arrH.map(( row ) => {
              let idrw = row.id;
              let vidrw = this.cuser.permiso.find(({ shcpe_numero }) => shcpe_numero === idrw);
              if(vidrw){
                //--Subpermiso existe--
                rwitem.push({id:row.id, label:row.label, link:row.link, parentId:row.parentId})
              }
            });
            //--Se crea el elemento final en array principal
            this.menuItems.push({id:element.id, label:element.label, icon:element.icon, subItems:rwitem});
          }else{
            //--No hay subitems se agrega el elemento
            this.menuItems.push(element)
          }
        }
      });
    });
  }

  /**
   * Returns true or false if given menu item has child or not
   * @param item menuItem
   */
  hasItems(item: MenuItem) {
    return item.subItems !== undefined ? item.subItems.length > 0 : false;
  }
  imgPerfil(){
    this.nimage = this.url+"usr_showima/"+this.idlogusr;
  }
  onSort({ column, direction }: SortEvent) {
    // resetting other headers
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });
    this.service.sortColumn = column;
    this.service.sortDirection = direction;
  }
  changeValue(i) {
    this.hideme[i] = !this.hideme[i];
  }
}
